import {state, transition, trigger, style, animate} from "@angular/animations";
import {Component, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {AbstractComponent, NavTabsComponent} from "@components";
import {Message} from "@model";
import {MessageService, TOAST_STATE, ToastService} from "@services";
import {ORGANISER_MESSAGES, USER_MESSAGES} from "../../../../app-routing.module";
import {debounceTime, distinctUntilChanged} from "rxjs";
import {environment} from "@environment";

@Component({
  selector: 'app-messages.component',
  templateUrl: 'messages.component.html',
  styleUrls: ['messages.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(200)
      ])
    ])]
})
export class MessagesComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input() messages: Message[] | undefined;
  @Input() isAdmin: boolean = false;
  activeNav: MessageTab = MessageTab.UNREAD;
  isLoading: boolean = false;
  queryParamsFirstChange: boolean = true;

  constructor(private messageService: MessageService, private translocoService: TranslocoService,
              private route: ActivatedRoute, private router: Router, private toastService: ToastService) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToQueryParamsChange();
  }

  subscribeToQueryParamsChange(): void {
    this.subscriptions.push(this.route.queryParams.subscribe((params: Params) => {
        const activeNav: MessageTab = params['read'] === 'true' ? MessageTab.READ : MessageTab.UNREAD;
        if (!this.queryParamsFirstChange) {

          this.messageService.getUserMessages(activeNav === MessageTab.READ ?? false, () => {
            this.isLoading = true;
          }, () => {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }).subscribe((messages: Message[]) => {
            this.messages = messages;
            this.activateTab(activeNav);
          });
        } else {
          this.queryParamsFirstChange = false;
          this.activateTab(activeNav);
        }
      })
    );
  }

  private activateTab(activeNav: MessageTab) {
    this.activeNav = activeNav;
  }


  onMarkAsRead(index: number | undefined) {
    ///todo
  }

  onDeleteAll() {
    //todo
  }

  onAddMessage(message: Message | undefined) {
    if (message) {
      this.messageService.addMessage(message, () => {
        this.toastService.showToast(TOAST_STATE.success,
          this.translocoService.translate("Message successfully added."));
      }, () => {
        this.toastService.showToast(TOAST_STATE.danger,
          this.translocoService.translate("Error! Message has not been added."));
      });
    }
  }

  onDeleteMessage(messageId: number | undefined): void {
    if (messageId) {
      this.messageService.deleteMessage(messageId, () => {
        this.toastService.showToast(TOAST_STATE.success,
          this.translocoService.translate("app.common.message.deleted.success"));
        this.messageService.getUserMessages(this.activeNav === MessageTab.READ ?? false).subscribe((messages: Message[]) => {
          this.messages = messages;
        });
      }, () => {
        this.toastService.showToast(TOAST_STATE.danger,
          this.translocoService.translate("app.common.message.deleted.error"));
      });
    }
  }

  public navigate(id: number | undefined) {
    const filter: boolean = id === MessageTab.READ;
    this.router.navigate([this.isAdmin ? ORGANISER_MESSAGES : USER_MESSAGES], {queryParams: {read: filter}});
  }

  protected readonly MessageTab = MessageTab;
}

enum MessageTab {
  UNREAD = 1,
  READ = 2,
}
